import React from "react";
import "./SayHelloSection.css";
import contactsection from "../../assets/Institute/contact-section.jpg";

const SayHelloSection = () => {
  return (
    <section className="hello-wrapper">
      <div className="hello-container">

        {/* Left side image */}
        <div className="hello-image-box">
          <img 
            src={contactsection} 
            alt="Say Hello"
            title="Contact NIECCE teacher training course team"
            className="hello-image"
          />
        </div>

        {/* Right content */}
        <div className="hello-content">
          <h2 className="hello-title">Say Hello</h2>

          <p className="hello-text">
            Have questions about admissions, centers, or general enquiries?
            We’re here to help you!
          </p>

          <ul className="hello-list">
            <li>
              For admissions, you can enroll directly from our course page —{" "}
              <a href="https://www.niecce.com/nttcourse" target="_blank" rel="noreferrer">
                Click Here
              </a>
            </li>

            <li>
              To find a NIECCE branch near you —{" "}
              <a href="https://www.niecce.com/contact" target="_blank" rel="noreferrer">
                Click Here
              </a>
            </li>

            <li>
              For any queries, submit your message below and our team will reach
              you within 3–4 business days.
            </li>
          </ul>
        </div>

      </div>
    </section>
  );
};

export default SayHelloSection;
